import { useConfig } from '@nexelem/config';
import { ProLightBell } from '@nexelem/icons/ProLightBell';
import { IconButton } from '@nexelem/components';

const handleNotificationClick = () => alert('The action is not ready yet!');

export const NotificationIcon = ({ className }: { className: string }) => {
  const { isNotification, isCountLimit, countLimit } = useConfig();
  const withIndicator = false;
  const count = 0;
  //TODO to fix when notifications are on
  if (!isNotification) {
    return null;
  }
  return (
    <IconButton
      className={className}
      // amount of NEW notifications
      count={count}
      countLimit={countLimit}
      Icon={ProLightBell}
      isCountLimit={isCountLimit}
      size="small"
      // TODO should be depend on NEW notifications
      withIndicator={withIndicator}
      onClick={handleNotificationClick}
    />
  );
};
